import type { FaireProductEntity } from "../../entity_types/product";

export const p_c3f7g32qdr: FaireProductEntity = {
  token: "p_c3f7g32qdr",
  type: "product",
  name: "Java Plum Blossom Honey - 5oz",
  brandName: "Wai Meli - Big Island Moonbow Farms L.L.C.",
  imageUrl:
    "https://cdn.faire.com/fastly/1492d401d4e24955d01f7f916fa7ddbb3e98b035fe93ae0e06593032a8310327.jpeg",
  priceDollars: 6.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4f6f241d58110bab78287e1eee4c806550d9502b3a4c9093aea38230ca762d62.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
